<div class="modal-body">
    <h4 class="text-success">Sorry... Je zult echt nog even moeten wachten...</h4>
    <button type="button" class="btn btn-warning btn-block" (click)="close()">Ok dan...</button>
</div>